import {historySvg as Icon__small__historySvg} from '../Icon__small/Icon__small--history.js';

export var history = {
  name: 'history',
  category: 'icon',
  colorable: true,
  svg: Icon__small__historySvg,
};
